import { KeyValue } from '@/main/models/common';
import { TranslationCultureResponse } from '@/main/models/response/translationCultureResponse';

export enum TranslateTypes {
  GET_TRANSLATES = '@translate/GET_TRANSLATES',
  SAVE_TRANSLATES = '@translate/SAVE_TRANSLATES',
  RESET_REDUCER_TRANSLATES = '@translate/RESET_REDUCER_TRANSLATES'
}

export interface TranslateState {
  readonly translates: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
    cultureUserLogged: string | null;
    lastSyncTranslations: string;
  };
}

export interface GetTranslates {
  type: typeof TranslateTypes.GET_TRANSLATES;
  payload: { culture: string };
}

export interface SaveTranslates {
  type: typeof TranslateTypes.SAVE_TRANSLATES;
  payload: {
    data: TranslationCultureResponse | null;
    cultureUserLogged: string | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerTranslates {
  type: typeof TranslateTypes.RESET_REDUCER_TRANSLATES;
}

export type TranslateActionTypes =
  | GetTranslates
  | SaveTranslates
  | ResetReducerTranslates;
